/**
* @file 框架-顶部-导出进度条
* */
<template>
  <div 
    class="header-down-notice"
    v-if="excelForm && excelForm.excelType && excelForm.status === 'waiting'"
  >
    <div class="header-down-cont">
      导出进度
      <div style="width: 200px; margin-left: 14px">
        <el-progress 
          hide-info 
          :percentage="Number(excelForm.progress)" 
          :stroke-width="6"
        ></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportProgress',
  props: {
    excelForm: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
.header-down-notice {
  position: fixed;
  right: 20px;
  z-index: 10000;
  border-radius: 4px;
  top: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(127, 103, 86, 0.1);
  color: #222222;

  .header-down-cont {
    padding: 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
}
</style>
